import React from "react";

export const FingerprintContext = React.createContext({str: ""});
